import { createBrowserHistory } from 'history'

let browserHistory = null
if (typeof window !== 'undefined') {
  browserHistory = createBrowserHistory()
}

export default browserHistory



// WEBPACK FOOTER //
// ./src/history.js